// Auto-generated from the client feather artwork (potrace vector trace).
// FEATHER_PATH and DROP_PATH are in potrace pixel space; render inside
// <g transform="translate(0,848) scale(0.1,-0.1)"> to map to a 1337x848 box.

export const FEATHER_VIEWBOX = "0 0 1337 848";
export const FEATHER_TRANSFORM = "translate(0,848) scale(0.1,-0.1)";
export const FEATHER_PATH = `M9145 6209 c-206 -9 -307 -23 -403 -55 -190 -63 -283 -135 -615 -477
-260 -267 -364 -363 -464 -425 -59 -38 -154 -85 -159 -79 -2 1 25 22 61 45 87
57 257 228 390 392 266 327 383 442 530 517 l70 35 -116 -5 c-411 -21 -794
-153 -1089 -378 -107 -81 -188 -156 -330 -304 -247 -259 -412 -409 -497 -454
-43 -22 -34 -10 26 35 84 63 198 190 342 380 67 87 141 183 166 212 24 28 41
52 37 52 -20 0 -220 -177 -419 -371 -214 -208 -356 -327 -457 -383 -27 -15
-48 -25 -48 -22 0 2 30 26 68 52 107 76 298 270 517 524 111 129 229 260 261
291 116 109 235 185 352 224 29 9 51 19 48 22 -6 6 -201 -13 -341 -33 -408
-59 -741 -160 -988 -300 -209 -119 -368 -272 -573 -551 -213 -291 -292 -381
-417 -474 -43 -33 -82 -59 -86 -59 -4 0 31 39 78 88 93 94 194 237 315 447
140 244 177 296 286 405 78 79 122 114 170 138 79 39 66 39 -92 6 -258 -54
-514 -156 -788 -312 -137 -78 -376 -250 -465 -334 -100 -94 -173 -195 -335
-463 -66 -109 -175 -245 -219 -274 l-25 -16 27 45 c17 30 33 83 47 160 51 278
81 363 162 456 39 44 40 46 12 26 -60 -41 -137 -136 -169 -207 -18 -38 -43
-115 -55 -170 -38 -170 -58 -228 -101 -293 -23 -35 -43 -61 -45 -60 -2 2 3 26
12 53 29 99 -9 206 -98 272 -48 35 -55 28 -15 -16 20 -22 40 -57 46 -78 14
-48 14 -137 1 -184 -9 -33 -73 -119 -89 -119 -4 0 -5 15 -4 33 5 42 -24 96
-66 124 -46 31 -55 29 -21 -5 36 -36 52 -91 39 -136 -5 -19 -15 -38 -22 -43
-12 -9 -165 -66 -702 -261 -166 -60 -361 -131 -445 -162 -79 -29 -274 -90
-350 -110 -25 -7 -119 -25 -209 -40 -190 -33 -185 -30 -383 -206 -136 -121
-207 -175 -355 -274 -62 -41 -113 -80 -113 -87 0 -18 5 -17 97 16 182 67 418
80 640 36 111 -22 134 -24 183 -14 77 16 120 44 189 126 150 179 284 280 476
358 149 60 395 147 665 234 140 45 295 96 344 113 85 28 93 29 150 18 118 -23
181 -70 225 -170 l20 -45 0 33 c2 78 -51 149 -144 193 -67 31 -52 37 45 19 85
-16 145 -62 205 -155 59 -91 82 -114 142 -144 63 -31 72 -25 17 12 -40 26 -57
48 -96 122 -29 56 -63 105 -90 129 -53 47 -38 44 106 -21 116 -52 150 -73 267
-159 48 -35 89 -64 92 -64 16 0 -194 200 -243 232 -66 43 -161 84 -238 103
-52 12 -54 13 -21 14 70 2 204 -31 286 -69 94 -44 185 -109 333 -240 130 -114
207 -170 297 -214 114 -56 139 -56 53 1 -78 52 -123 96 -251 248 -121 144
-266 252 -396 296 -35 11 -62 23 -60 26 7 6 177 -52 243 -83 71 -34 238 -144
338 -223 229 -183 429 -284 612 -310 115 -16 266 -23 259 -11 -3 5 -17 10 -30
10 -37 0 -192 57 -275 102 -102 54 -208 132 -364 266 -215 187 -353 270 -522
316 -49 14 -78 25 -64 25 46 2 213 -50 294 -91 106 -53 204 -120 352 -239 223
-180 386 -276 577 -341 82 -28 107 -32 232 -36 168 -5 515 27 515 48 0 3 -27
12 -59 18 -135 28 -300 137 -516 342 -263 249 -463 371 -708 431 -43 10 -88
19 -100 19 -12 0 -29 5 -37 10 -24 15 95 1 206 -25 104 -25 261 -89 356 -146
73 -44 201 -144 334 -259 61 -53 139 -117 175 -142 204 -146 427 -217 629
-202 l95 8 -55 8 c-323 49 -491 139 -855 458 -203 177 -368 274 -565 330 -37
11 -54 19 -40 19 61 2 267 -71 395 -140 62 -34 206 -137 310 -224 33 -27 84
-69 112 -92 262 -217 546 -333 811 -333 90 0 273 20 477 53 l80 13 -60 13
c-246 52 -450 167 -765 430 -313 262 -478 358 -725 422 -92 24 -101 28 -53 23
80 -8 229 -49 318 -87 143 -62 263 -143 556 -373 71 -56 156 -119 189 -142
279 -188 557 -273 787 -242 106 14 549 98 689 131 102 23 150 43 84 33 -56 -8
-176 20 -262 61 -112 55 -200 127 -443 368 -256 253 -362 338 -526 420 -88 44
-143 64 -224 82 l-65 15 118 -5 c174 -8 352 -60 507 -147 97 -54 241 -158 405
-292 88 -72 189 -150 225 -174 129 -88 280 -152 450 -194 33 -8 106 -13 185
-12 141 2 276 27 535 100 150 43 358 94 384 94 34 0 8 13 -63 31 -137 35 -291
131 -466 289 -222 202 -367 318 -490 391 -93 56 -122 70 -240 111 -125 43
-113 51 20 12 113 -32 285 -115 401 -193 49 -33 163 -119 254 -192 195 -157
297 -225 423 -284 155 -73 230 -90 387 -89 141 1 213 12 535 84 77 17 157 34
178 37 37 6 35 7 -50 28 -177 45 -312 128 -543 332 -80 70 -169 147 -197 171
-88 73 -272 191 -334 213 -65 24 -74 39 -12 19 76 -24 271 -133 388 -216 66
-46 183 -129 260 -184 240 -171 464 -268 665 -288 118 -12 230 2 458 57 l193
48 -54 12 c-123 27 -223 89 -472 291 -266 216 -346 271 -481 329 -95 42 -63
39 42 -3 147 -60 277 -143 489 -312 241 -192 419 -274 596 -274 74 0 218 34
333 78 l49 19 -82 7 c-45 4 -106 14 -134 23 -99 29 -241 112 -420 246 -98 74
-206 148 -240 167 -89 47 -95 59 -8 15 41 -20 111 -62 155 -93 45 -30 142 -97
217 -147 274 -185 476 -236 657 -165 42 17 88 36 101 44 23 13 22 13 -26 20
-70 9 -326 136 -309 153 3 3 28 -9 56 -26 107 -66 282 -120 353 -108 17 3 79
24 136 48 l104 43 -74 16 c-41 9 -90 24 -109 33 -19 10 -26 15 -15 11 168 -49
228 -45 372 25 120 58 283 152 283 162 0 13 -102 94 -170 137 -124 77 -246
109 -384 99 -61 -4 -75 -3 -56 5 14 5 76 12 137 15 70 4 110 9 106 16 -8 13
-273 186 -353 230 -105 58 -256 116 -400 154 -127 34 -144 36 -295 37 l-160 1
-108 -38 c-109 -38 -211 -90 -412 -209 -101 -60 -241 -128 -262 -128 -4 1 37
24 92 54 55 29 165 92 245 141 295 179 478 235 730 223 l105 -5 -85 29 c-126
43 -407 114 -550 139 -279 47 -441 -6 -780 -255 -189 -139 -342 -237 -455
-292 -63 -30 -120 -54 -126 -52 -6 2 29 27 78 56 91 54 208 145 374 290 186
162 318 249 439 288 30 10 50 19 45 20 -32 9 -368 66 -460 78 -167 22 -386 30
-491 17 -166 -20 -317 -81 -495 -199 -111 -74 -156 -109 -380 -298 -220 -185
-374 -291 -510 -352 -96 -43 -122 -48 -58 -10 113 67 220 159 429 368 219 220
306 298 398 358 96 63 225 118 297 129 l50 7 -45 7 c-56 9 -261 8 -485 -2z
m985 -74 c-108 -29 -150 -45 -231 -85 -156 -78 -212 -118 -484 -345 -194 -161
-301 -243 -356 -269 -39 -19 -35 -15 68 60 34 25 119 95 188 157 376 333 510
420 730 476 109 27 116 29 145 29 14 1 -13 -10 -60 -23z m-1150 -29 c0 -2 -30
-21 -67 -42 -179 -99 -269 -172 -553 -449 -195 -190 -269 -257 -345 -309 -29
-21 -25 -15 15 20 30 26 161 154 290 284 259 260 388 366 553 450 97 50 107
54 107 46z m-950 -90 c0 -2 -42 -31 -94 -64 -135 -88 -268 -212 -448 -417 -86
-99 -186 -206 -220 -239 -88 -81 -204 -174 -241 -192 l-32 -15 35 28 c75 59
218 205 357 363 241 274 367 385 560 495 82 47 83 47 83 41z m3245 -36 c-132
-28 -244 -72 -335 -130 -14 -9 -43 -27 -65 -39 l-40 -23 29 25 c106 92 339
185 461 186 29 0 15 -6 -50 -19z m-4926 -264 c-163 -111 -337 -283 -544 -536
-139 -170 -293 -339 -344 -377 -23 -18 -11 0 35 50 72 77 156 179 314 383 95
122 297 329 380 391 70 51 232 153 244 153 6 0 -33 -29 -85 -64z m5721 -36 c0
-5 -15 -10 -34 -10 -70 0 -267 -60 -443 -136 -175 -75 -283 -114 -313 -113 -8
0 8 9 35 19 28 10 82 32 120 50 261 121 404 169 560 189 39 4 71 9 73 10 1 0
2 -3 2 -9z m-2374 -118 c-9 -14 -148 -106 -181 -119 -24 -10 -26 -10 -11 0 10
7 57 38 105 69 92 61 95 62 87 50z m2825 -18 c39 -9 69 -17 67 -19 -2 -2 -46
0 -98 3 -154 11 -283 -7 -467 -64 -17 -5 -17 -5 0 6 55 36 276 87 380 89 26 1
80 -6 118 -15z m-7246 -82 c-6 -5 -35 -26 -65 -47 -138 -98 -284 -262 -457
-516 -55 -80 -126 -179 -158 -220 -63 -80 -210 -229 -225 -229 -6 0 7 17 28
38 72 72 143 164 262 341 141 210 226 319 328 419 75 74 203 176 257 205 34
18 44 21 30 9z m5675 -82 c448 -19 916 -65 1490 -145 288 -41 307 -43 450 -65
74 -11 149 -20 165 -21 63 -3 -60 -18 -150 -18 -100 -1 -217 8 -505 38 -368
38 -965 91 -1145 100 -874 47 -1670 5 -2750 -145 -243 -34 -504 -74 -730 -113
-60 -11 -168 -29 -240 -42 -166 -28 -646 -120 -835 -160 -252 -53 -423 -90
-485 -104 -326 -75 -453 -106 -660 -157 -132 -33 -278 -70 -325 -83 -378 -103
-421 -115 -845 -237 -412 -118 -1073 -329 -1590 -507 -218 -76 -620 -226 -944
-353 -43 -17 -57 -19 -72 -10 -48 30 -129 -6 -129 -58 0 -11 -5 -20 -11 -20
-12 0 -131 -47 -312 -123 -59 -25 -107 -44 -107 -43 0 2 44 33 98 69 53 37
147 108 209 160 164 136 210 161 351 187 127 24 283 62 347 85 22 8 141 50
265 94 124 43 268 95 320 114 52 20 196 72 320 117 124 46 268 98 320 118 209
76 724 245 995 326 155 46 426 124 490 141 28 7 136 37 240 65 197 53 680 176
750 189 22 5 110 25 195 44 867 201 1957 386 2810 477 417 44 736 70 1030 83
174 8 781 6 990 -3z m-809 -273 c94 -47 224 -131 344 -222 44 -33 118 -90 165
-126 101 -77 142 -104 235 -158 79 -46 80 -55 1 -14 -81 43 -187 116 -376 258
-196 148 -290 210 -400 266 -41 21 -70 38 -65 39 6 0 49 -19 96 -43z m-5487
-8 c-4 -7 -28 -39 -53 -73 -25 -33 -73 -106 -105 -161 -185 -315 -236 -386
-337 -470 -13 -11 -3 5 22 35 53 63 135 189 228 349 67 115 119 189 196 278
43 49 66 69 49 42z m4210 -90 c91 -30 232 -95 315 -144 45 -27 101 -68 383
-282 220 -167 396 -260 563 -299 l60 -14 -85 5 c-136 7 -313 75 -469 180 -64
43 -107 77 -370 288 -187 150 -354 246 -501 286 -27 7 -29 9 -11 10 12 1 64
-13 115 -30z m-1055 -180 c200 -67 354 -160 651 -394 304 -239 494 -339 728
-381 l77 -14 -76 4 c-103 6 -213 37 -339 98 -155 75 -266 151 -536 367 -174
141 -343 241 -523 313 -117 46 -109 49 18 7z m-192 -42 c170 -56 322 -150 523
-322 348 -297 527 -403 770 -455 50 -11 72 -18 54 -19 -50 -2 -212 44 -299 83
-150 69 -301 173 -530 366 -248 209 -455 326 -670 380 l-40 10 46 -5 c26 -2
91 -19 146 -38z m-1005 -163 c160 -51 339 -147 477 -257 36 -29 146 -123 246
-210 256 -226 437 -339 615 -387 74 -19 74 -19 20 -14 -212 24 -410 138 -701
406 -276 255 -470 384 -684 459 -102 35 -82 37 27 3z m2285 -157 c158 -119
252 -179 364 -231 87 -42 222 -84 297 -93 81 -9 77 -26 -4 -18 -218 21 -411
120 -691 351 -169 139 -162 138 34 -9z m1358 -29 c78 -39 172 -71 258 -88 31
-6 57 -14 57 -16 0 -7 -84 5 -155 23 -68 17 -246 106 -272 136 -18 21 -18 21
12 0 17 -11 62 -36 100 -55z m-5358 -308 c120 -49 217 -108 348 -211 177 -140
185 -154 13 -25 -155 117 -281 189 -458 264 -14 6 -20 11 -13 11 6 1 56 -17
110 -39z m4295 -5 c21 -8 66 -19 100 -26 69 -13 116 -32 58 -23 -68 10 -166
38 -217 61 -60 28 -73 42 -15 17 20 -9 54 -22 74 -29z m-1179 -168 c98 -62
190 -101 287 -122 53 -11 58 -14 29 -14 -94 -2 -288 83 -390 171 -42 37 -36
34 74 -35z m-5657 -440 c-117 -73 -178 -122 -263 -211 -147 -153 -142 -151
-403 -152 -165 0 -232 -4 -288 -17 -132 -31 -115 -21 159 87 93 37 97 38 122
21 46 -30 102 -5 125 56 8 20 28 32 94 57 45 17 137 52 203 77 122 47 256 95
265 94 3 0 -4 -6 -14 -12z`;

export const DROP_PATH = `M1028 2960 c-104 -235 -113 -272 -83 -330 17 -32 70 -54 108 -45 14
4 36 18 49 32 34 37 31 106 -12 218 -18 50 -36 106 -40 125 -6 35 -6 35 -22 0z`;

// The oxblood ink drop is small relative to the feather. Enlarge it around its
// attachment point at the nib (potrace ~(1039,2960)) so it reads as a proper
// teardrop, applied at the source so the proportion stays identical everywhere.
export const DROP_TRANSFORM = "translate(1039,2960) scale(1.55) translate(-1039,-2960)";
